module.exports = __webpack_public_path__ + "media/assets/images/nexa-19eebffac70617ab1dc9bdb990febab1.png";